import { render, staticRenderFns } from "./payslip.vue?vue&type=template&id=4ec14617&scoped=true"
import script from "./payslip.vue?vue&type=script&lang=js"
export * from "./payslip.vue?vue&type=script&lang=js"
import style0 from "./payslip.vue?vue&type=style&index=0&id=4ec14617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec14617",
  null
  
)

export default component.exports